import { useState } from 'react';
import { Phone } from 'lucide-react';
import {
  PHONE_COUNTRIES,
  formatCountryOption,
  formatPhonePreview,
  getCountryByCode,
  validateNationalPhone,
} from '@/lib/phoneAuth';

export default function PhoneCountryInput({
  countryCode,
  onCountryCodeChange,
  phone,
  onPhoneChange,
  phoneTestId,
  countryTestId,
  disabled = false,
}) {
  const country = getCountryByCode(countryCode);
  const preview = formatPhonePreview(countryCode, phone);

  return (
    <div className="space-y-3">
      <div>
        <label className="text-xs font-medium text-slate-500">Country code</label>
        <div className="mt-1 flex items-center gap-2 border border-slate-200 rounded-lg px-3 py-2.5 bg-white">
          <select
            data-testid={countryTestId}
            value={countryCode}
            disabled={disabled}
            onChange={(e) => onCountryCodeChange(e.target.value)}
            className="flex-1 outline-none text-sm bg-transparent"
          >
            {PHONE_COUNTRIES.map((c) => (
              <option key={c.code} value={c.code}>
                {formatCountryOption(c)} {c.label}
              </option>
            ))}
          </select>
        </div>
      </div>
      <div>
        <label className="text-xs font-medium text-slate-500">Phone number</label>
        <div className="mt-1 flex items-center gap-2 border border-slate-200 rounded-lg px-3 py-2.5">
          <span className="text-slate-700 text-sm font-medium">{country.dial}</span>
          <Phone className="w-4 h-4 text-slate-400" />
          <input
            data-testid={phoneTestId}
            inputMode="numeric"
            pattern="[0-9]*"
            maxLength={country.digits || 15}
            placeholder={country.digits ? `${country.digits}-digit number` : 'Mobile number'}
            value={phone}
            disabled={disabled}
            onChange={(e) => onPhoneChange(e.target.value.replace(/\D/g, ''))}
            className="flex-1 outline-none text-base"
          />
        </div>
        {preview && (
          <p className="text-xs text-slate-500 mt-2" data-testid="phone-e164-preview">
            Stored as: <span className="font-medium text-slate-700">{preview}</span>
          </p>
        )}
      </div>
    </div>
  );
}

export function validatePhoneCountryInput(countryCode, phone) {
  return validateNationalPhone(countryCode, phone);
}
